<template>
    <div>
        <h2 class="mt-6 text-3xl leading-9 font-extrabold text-gray-900">
            {{ $t('auth.forgotPassword.pageTitle') }}
        </h2>

        <p class="mt-6 flex flex-col items-center justify-between text-sm leading-5">
            {{ $t('auth.forgotPassword.instructions') }}
        </p>

        <div class="mt-8">
            <form class="mt-6" @submit="resetPassword">
                <apexo-input
                    classes="w-full"
                    label="Adresse courriel"
                    name="email"
                    placeholder="example@apexo.ca"
                    v-model="email"
                />

                <div class="flex rounded border border-red-200 mt-4 p-4 bg-red-100 text-red-600 text-sm" v-if="error">
                    {{ $t(error) }}
                </div>

                <apexo-button
                    class="mt-6"
                    :disabled="!email"
                    @click="resetPassword"
                >
                    {{ $t('auth.forgotPassword.send') }}
                </apexo-button>
            </form>
        </div>
    </div>
</template>

<script>
    import ApexoButton from '../../components/Elements/ApexoButton.vue';
    import ApexoInput from '../../components/Elements/ApexoInput.vue';

    export default {
        components: {
            ApexoButton,
            ApexoInput,
        },

        data() {
            return {
                email: '',
                error: '',
            };
        },

        methods: {
            async resetPassword() {
                if (!this.email) {
                    return;
                }

                try {
                    await this.$axios.post('/forgot-password', {
                        email: this.email,
                    });
                } catch (error) {
                    const message = error.message;
                    console.log(message);
                    switch (message) {
                        case 'Request failed with status code 422':
                            this.error = 'auth.forgotPassword.userNotFound';
                            break;
                        case 'Request failed with status code 404':
                            this.error = 'auth.forgotPassword.unknownError';
                            break;
                        case 'Request failed with status code 502':
                            this.error = 'auth.forgotPassword.unknownError';
                            break;
                    }
                }
            },
        },
    };
</script>
